import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a5a6016"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-intro-contact" }
const _hoisted_2 = { class: "signup-intro-contact__description" }
const _hoisted_3 = { class: "signup-intro-contact__email" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "signup-intro-contact__or" }
const _hoisted_6 = { class: "signup-intro-contact__demo-link" }
const _hoisted_7 = ["href"]

import { useI18n } from 'vue-i18n'

import useMediaQuery from '@/composables/common/useMediaQuery'

import env from '@/app/env'

import AppButton from '@C/ui/button/AppButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupIntroContact',
  setup(__props) {

const { t } = useI18n()

const { isMobile, isTablet } = useMediaQuery()

function openDemo() {
  window.open(env.demoLink, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('signupPage.contactSupport')), 1),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref(t)('common.messages.sendEmailTo')) + ": ", 1),
      _createElementVNode("a", {
        href: `mailto:${_unref(env).contactEmail}`
      }, _toDisplayString(_unref(env).contactEmail), 9, _hoisted_4)
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('common.messages.or')), 1),
    _createElementVNode("p", _hoisted_6, [
      _createTextVNode(_toDisplayString(_unref(t)('common.messages.bookDemoHere')) + " ", 1),
      _createElementVNode("a", {
        href: _unref(env).demoLink,
        target: "_blank"
      }, _toDisplayString(_unref(t)('common.messages.here')), 9, _hoisted_7)
    ]),
    (_unref(isMobile) || _unref(isTablet))
      ? (_openBlock(), _createBlock(AppButton, {
          key: 0,
          class: "signup-intro-contact__button app-button_lg",
          onClick: openDemo
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.messages.bookDemoHere')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})